import { createFileRoute } from "@tanstack/react-router";
import Superusers from "@/features-root-user/user";
import { superusersQueryOptions } from "@/features-root-user/service/user";
import { queryClient } from "@/main";

export const Route = createFileRoute("/_root/root-user/user/")({
  component: Superusers,
  loader: async () => {
    queryClient.ensureQueryData(superusersQueryOptions);
  },
});
